import API from '@/api';
import V3API from '@/api/v3';
// import { activityNov2022 } from '@/api/data/roundActivity';

const RESET_STATE = 'RESET_STATE';

const GET_ROUNDS = 'GET_ROUNDS';
const GET_ROUNDS_SUCCESS = 'GET_ROUNDS_SUCCESS';
const GET_ROUNDS_FAILED = 'GET_ROUNDS_FAILED';

const SHOW_ROUND = 'SHOW_ROUND';
const SHOW_ROUND_SUCCESS = 'SHOW_ROUND_SUCCESS';
const SHOW_ROUND_FAILED = 'SHOW_ROUND_FAILED';

const GET_MATCH = 'GET_MATCH';
const GET_MATCH_SUCCESS = 'GET_MATCH_SUCCESS';
const GET_MATCH_FAILED = 'GET_MATCH_FAILED';

const namespaced = true;

//* Round initial state
const state = {
  all: [],
  roundDetails: {},
  matchDetails: {},
  loading: false,
  loadingMatch: false,
};

const emptyState = {
  all: [],
  roundDetails: {},
  matchDetails: {},
  loading: false,
  loadingMatch: false,
};

//* Round getters
const getters = {
  roundList: (state) => {
    return state.all;
  },

  roundDetails: (state) => {
    return state.roundDetails;
  },

  loading: (state) => {
    return state.loading;
  },

  loadingMatch: (state) => {
    return state.loadingMatch;
  },

  matchDetails: (state) => {
    return state.matchDetails;
  },
};

//* Round getters
const actions = {
  // * reset state
  async resetState({ commit }) {
    commit(RESET_STATE);
  },

  // * all fetches the rounds list from the API for a given user
  async all({ commit }, payload) {
    let response;

    commit(GET_ROUNDS);

    try {
      response = await API.rounds.list();

      response = await Promise.all(
        response?.data?.map(async (round) => {
          if (round.seriesUUID !== undefined) {
            const courseResponse = await API.courses.show(round.seriesUUID);
            round.courseName = courseResponse?.data?.name;
            Object.assign(round, { course: courseResponse.data }); // ? should the whole course be added
            return round;
          }
        })
      );
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(GET_ROUNDS_FAILED);
        reject(err);
      });
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ROUNDS_FAILED);
        reject(response);
      } else {
        commit(GET_ROUNDS_SUCCESS, response);
        // Return GET data  within promise
        // resolve(response.data)
        resolve(response);
      }
    });
  },

  // * show fetches the round list from the API
  async show({ commit }, payload) {
    let response;
    let combinedArray;

    commit(SHOW_ROUND);

    try {
      response = await API.rounds.show(payload);

      if (response?.data?.seriesUUID !== undefined) {
        const courseResponse = await API.courses.show(response?.data?.seriesUUID);
        Object.assign(response.data, { course: courseResponse?.data }); // ? should the whole course be added
      }
      if (response?.data?.eventID !== undefined) {
        const eventResponse = await API.events.show(response?.data?.eventID);
        Object.assign(response.data, { event: eventResponse?.data });
      }
    } catch (err) {
      response = err;
    }

    try {
      if (response?.data?.players?.length > 0) {
        combinedArray = await Promise.all(
          response.data?.players?.map(async (player) => {
            if (player !== undefined) {
              const playerRes = await API.users.show(player.id);
              if (playerRes) {
                player.name = playerRes?.data?.displayName;
              }

              return {
                ...response.data,
              };
            }
          })
        );

        response.data = Object.assign({}, ...combinedArray);
      }
    } catch (e) {
      return new Promise((resolve, reject) => {
        commit(SHOW_ROUND_FAILED);
        reject(e);
      });
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(SHOW_ROUND_FAILED);
        reject(response);
      } else {
        commit(SHOW_ROUND_SUCCESS, response.data);
        // Return GET data  within promise
        resolve(response.data);
      }
    });
  },

  // * allUserRounds fetches the rounds list from the API for a given user
  async allUserRounds({ commit }, payload) {
    let response;

    commit(GET_ROUNDS);

    try {
      response = await API.rounds.allUserRounds(payload);

      // if (Array.isArray(response?.data)) {
      //   //* Manually insert additional marketing card item
      //   response.data.unshift(activityNov2022);
      // }
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(GET_ROUNDS_FAILED);
        reject(err);
      });
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ROUNDS_FAILED);
        reject(response);
      } else {
        commit(GET_ROUNDS_SUCCESS, response);
        // Return GET data  within promise
        // resolve(response.data)
        resolve(response);
      }
    });
  },

  // * ===================== V3 =====================
  // * matchGet returns the match/round details for a round
  async matchGet({ commit }, payload) {
    let response;

    commit(GET_MATCH);

    try {
      response = await V3API.rounds.matchGet(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_MATCH_FAILED);
        reject(response);
      } else {
        commit(GET_MATCH_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
};

//* Round mutations
const mutations = {
  [RESET_STATE](state) {
    state = Object.assign(state, emptyState);
  },

  [GET_ROUNDS](state) {
    state.loading = true;
  },

  [GET_ROUNDS_SUCCESS](state, rounds) {
    state.all = rounds;
    state.loading = false;
  },

  [GET_ROUNDS_FAILED](state) {
    state.loading = false;
  },

  [SHOW_ROUND](state) {
    state.loading = true;
  },

  [SHOW_ROUND_SUCCESS](state, round) {
    state.roundDetails = { ...round };
    state.loading = false;
  },

  [SHOW_ROUND_FAILED](state) {
    state.loading = false;
  },

  [GET_MATCH](state) {
    state.loadingMatch = true;
  },

  [GET_MATCH_SUCCESS](state, round) {
    state.matchDetails = { ...round };
    state.loadingMatch = false;
  },

  [GET_MATCH_FAILED](state) {
    state.loadingMatch = false;
  },
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
